import { useEffect, useState } from 'react';
import { fetchVideoHealth } from '../api';
import type { VideoHealth } from '../types';

const POLL_INTERVAL_MS = 5000;

/**
 * Hook for the video service's `/health` endpoint.
 *
 * Mirrors the lightning `useHealth` shape but reads the video-specific
 * response (counts live under `health.counts.{pending,processing,
 * completed,failed}` rather than the flat `*_jobs` lightning fields).
 */
export function useVideoHealth() {
  const [health, setHealth] = useState<VideoHealth | null>(null);
  const [beLive, setBeLive] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const data = await fetchVideoHealth();
        if (cancelled) return;
        setHealth(data);
        setBeLive(true);
      } catch {
        if (cancelled) return;
        setBeLive(false);
      }
    };
    tick();
    const id = window.setInterval(tick, POLL_INTERVAL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, []);

  return { health, beLive };
}
